import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  open: false
}

const LoadingMaskSlice = createSlice({
  name: 'loadingMask',
  initialState,
  reducers: {
    handleLoadingMaskOpen: (state) => {
      state.open = true
    },
    handleLoadingMaskClose: (state) => {
      state.open = false
    }
  }
})

export const { handleLoadingMaskOpen, handleLoadingMaskClose } = LoadingMaskSlice.actions

export default LoadingMaskSlice.reducer